import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const base = `${u}/projects`;

export const getEpics = (projectId) =>
  apiFetch(`${base}/${projectId}/epics`).then(r => r.ok ? r.json() : Promise.reject(r));

export const getEpic = (projectId, epicId) =>
  apiFetch(`${base}/${projectId}/epics/${epicId}`).then(r => r.ok ? r.json() : Promise.reject(r));

export const createEpic = (projectId, data) =>
  apiFetch(`${base}/${projectId}/epics`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const updateEpic = (projectId, epicId, data) =>
  apiFetch(`${base}/${projectId}/epics/${epicId}`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const deleteEpic = (projectId, epicId) =>
  apiFetch(`${base}/${projectId}/epics/${epicId}`, { method: "DELETE" });
